import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Button from 'design-system/Button';

import theme from 'styles/theme';

const shouldForwardProp = (prop: string) =>
  !['selected', 'showTour'].includes(prop);

type SelectedType = {
  selected?: boolean;
};

export const MoreIcon = styled('span', { shouldForwardProp })<SelectedType>`
  margin: 0;
  color: ${({ selected }) => (selected ? '#288EFD' : '#656565')};
  font-size: 1.3rem;
`;

export const Divider = styled.div`
  width: 1px;
  height: 30px;
  background-color: rgba(0, 0, 0, 0.1);
`;

type ContainerProps = {
  showTour: boolean;
};

export const Container = styled('header', { shouldForwardProp })<ContainerProps>`
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 14px 48px 14px 24px;

  @media (max-width: 1100px) {
    display: none;
  }

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
    `}
`;

export const BoxTwoBars = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 0;
`;

export const ContainerWrap = styled.div`
  position: relative;
`;

export const BoxNameAddress = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const Name = styled.div`
  font-size: 16px;
  color: ${theme.colors.blue};
  font-family: 'Mangueira bold';
`;

export const BoxAddressBreadcrumb = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Address = styled.div`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  color: #3d3d3d;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Breadcrumb = styled.div`
  font-size: 12px;
  color: ${theme.colors.gray};
  margin-top: 12px;
  margin-left: -16px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const TwoBars = styled.div`
  color: ${theme.colors.blueClean};
  font-size: 16px;
  font-family: 'Mangueira Bold', 'Mangueira', sans-serif;
  margin-right: 5px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const BoxNotificationProfile = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const HeaderActionButton = styled(Button)`
  width: 158px;
  height: 39px;
  min-height: 39px;
  padding: 10px;
  gap: 8px;
  border-radius: 8px;
  flex-shrink: 0;
  box-sizing: border-box;
  opacity: 1;
  font-family: 'Mangueira', sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
`;

export const BoxResponsiveMore = styled.div`
  display: none;
`;

export const ResponsiveGradient = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  min-width: 0;

  @media (max-width: 768px) {
    align-items: center;
    padding: 10px 20px;
    border-radius: 5px;
    background: linear-gradient(#efefef, #ebebeb);
  }
`;

type TourBellWrapProps = {
  showTour?: boolean;
};

export const TourBellWrap = styled('div', { shouldForwardProp })<TourBellWrapProps>`
  position: relative;

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
      background-color: #f5f5f5;
      padding: 2px 8px;
      border-radius: 8px;
    `}
`;
